import 'src/styles/ui/skeleton.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * A shimmering placeholder block shown while content loads. Size it with
 * `width` / `height` (a number = px, or any CSS length string) and set `circle`
 * for a round shape. Generic — usable by any feature to build loading skeletons
 * that mirror the shape of the content they stand in for.
 */
const Skeleton = ({ width, height, circle, className, style, ...props }) => (
  <span
    className={classNames('skeleton', { 'skeleton--circle': circle }, className)}
    style={{ width, height, ...style }}
    aria-hidden='true'
    {...props}
  />
);

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  circle: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

Skeleton.defaultProps = {
  width: '100%',
  height: 12,
  circle: false,
  className: '',
  style: null,
};

export default Skeleton;
